const PRODUCT_CURRENCY_SYMBOLS: Record<string, string> = {
  TRY: "₺",
}

export function formatProductMoney(amount: number, currencyCode: string): string {
  const code = currencyCode.toUpperCase()
  const formatted = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount)
  return `${PRODUCT_CURRENCY_SYMBOLS[code] ?? `${code} `}${formatted}`
}

export function productDiscountPercentage(compareAt: number, current: number): number | null {
  if (!(compareAt > current) || compareAt <= 0 || current < 0) return null
  return Math.round(((compareAt - current) / compareAt) * 100)
}
